<section class="facet-filter">
  <h3 class="facet-subtitle" attr.aria-label="{{ 'adura.status.label' | translate }}">{{ 'adura.status.label' | translate }}</h3>
  <div>
    <ng-container *ngIf="!this.status || this.status.length === 0">
      <p><small>{{ 'search.noFilter' | translate }}</small></p>
    </ng-container>
    <nav [attr.aria-label]="'document.status.list' | translate">
      <div class="list-inline tags">
        <ng-container *ngFor="let state of status">
          <div class="flex-container">
            <input type="checkbox" class="filter-checkbox sr-only" id="status_{{state.id}}"
                   (click)="changeStatus('status_' + state.id)"
                   [checked]="isStatusActive(state.id)">
            <label class="filter-checkbox-label" [ngClass]="(state.count === 0)?'filter-element-background':''"
                   for="status_{{state.id}}"
                   role="checkbox"
                   [attr.aria-label]="('adura.status.label' | translate) + ': ' + (state.name | translate) + ', ' +
                   ('global.total' | translate) + ': ' + state.count"
                   [attr.aria-checked]="(isStatusActive(state.id))?'true':'false'">
              {{ state.name | translate }}
            </label>
            <span class="filter-checkbox-number" aria-hidden="true">{{ state.count}}</span>
          </div>
        </ng-container>
      </div>
    </nav>
  </div>
</section>
